import { useRoutes } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import { routes } from './Routes';
import { UserAuthProvider } from './context/UserAuth';
import { DarkModeProvider } from './context/DarkMode';

function App() {
  const elements = useRoutes(routes);
  return (
    <UserAuthProvider>
      <DarkModeProvider>
        <div className='App'>
          <Navbar />
          {elements}
        </div>
      </DarkModeProvider>
    </UserAuthProvider>
  );
}

export default App;
